// extracted by css-extract-rspack-plugin
var _1 = "lf";
export { _1 as "expandableListComponent" }
